"use client";

import { useContext, useState } from "react";
import { Checkbox } from "~/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/select";
import { preparationAnalysisOutcomes } from "./metadata";
import type { ListFilters } from "./listProjection";
import { HeaderFilterPortal } from "./HeaderFilter";

export const colorChoices = [["all", "Все цвета"], ["white", "Белые"], ["black", "Чёрные"], ["unknown", "Неизвестен"]] as const;
export const scoreChoices = [["all", "Все результаты"], ["1", "1"], ["0.5", "1/2"], ["0", "0"], ["unknown", "Неизвестен"]] as const;
export const analysisChoices = [["all", "Все"], ...preparationAnalysisOutcomes.map(({ code, label }) => [code, label] as const), ["unknown", "Без результата анализа"]] as const;
export const commentPresenceChoices = [["all", "Все"], ["present", "С комментарием"], ["absent", "Без комментария"]] as const;

export function UserCommentPresenceFilter({ filters, onChange }: { filters: ListFilters; onChange: (filters: ListFilters) => void }) {
  return <ListChoice label="Наличие комментария" value={filters.commentPresence ?? "all"} choices={commentPresenceChoices} onChange={(commentPresence) => onChange({ ...filters, commentPresence })} />;
}

export function StudentColorFilter({ filters, onChange }: { filters: ListFilters; onChange: (filters: ListFilters) => void }) {
  return <ListChoice label="Цвет игрока" value={filters.color ?? "all"} choices={colorChoices} onChange={(color) => onChange({ ...filters, color })} />;
}

export function StudentScoreFilter({ filters, onChange }: { filters: ListFilters; onChange: (filters: ListFilters) => void }) {
  return <ListChoice label="Результат партии" value={String(filters.score ?? "all")} choices={scoreChoices} onChange={(score) => onChange({ ...filters, score: score === "all" || score === "unknown" ? score : Number(score) as 0 | 0.5 | 1 })} />;
}

export function PreparationAnalysisFilter({ filters, onChange }: { filters: ListFilters; onChange: (filters: ListFilters) => void }) {
  return <ListChoice label="Результат анализа" value={filters.analysis ?? "all"} choices={analysisChoices} onChange={(analysis) => onChange({ ...filters, analysis })} />;
}

export function ListChoice<T extends string>({ label, value, choices, onChange }: {
  label: string; value: T; choices: readonly (readonly [T, string])[]; onChange: (value: T) => void;
}) {
  const portal = useContext(HeaderFilterPortal);
  const [open, setOpen] = useState(false);
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | undefined>();
  return <Select value={value} onValueChange={(next) => onChange(next as T)} open={open} onOpenChange={(next) => {
    setPortalContainer(portal?.current ?? undefined);
    setOpen(next);
  }}>
    <SelectTrigger aria-label={label} className="w-full min-w-0 gap-2 [&>span]:min-w-0 [&>svg]:shrink-0"><SelectValue /></SelectTrigger>
    <SelectContent portalContainer={portalContainer}>{choices.map(([key, text]) => <SelectItem key={key} value={key}>{text}</SelectItem>)}</SelectContent>
  </Select>;
}

export function ListFilterControls({ filters, onChange }: { filters: ListFilters; onChange: (filters: ListFilters) => void }) {
  return <div className="space-y-3">
    {/* Keep pointer focus inside the panel until native label activation focuses its checkbox. */}
    <label tabIndex={-1} className="flex items-center gap-2 text-sm"><Checkbox checked={filters.showArchived === true} onCheckedChange={(value) => onChange({ ...filters, showArchived: value === true })} />Показывать архивные</label>
    <label tabIndex={-1} className="flex items-center gap-2 text-sm"><Checkbox checked={filters.favoritesOnly === true} onCheckedChange={(value) => onChange({ ...filters, favoritesOnly: value === true })} />Только избранные</label>
  </div>;
}
